import React from 'react';
import { useSlackBotInstallation } from './use-slack-bot-installation';
import {
  ToolConnectionStatusBadge,
  ToolConnectionStatusCard,
} from './tool-connection-status';

export const SlackCocoInstalledBadge: React.FC = () => {
  const { installed } = useSlackBotInstallation();

  if (!installed) {
    return null;
  }

  return <ToolConnectionStatusBadge label="Coco installed" />;
};

export const SlackCocoInstalledCard: React.FC = () => {
  const { installed, teamId } = useSlackBotInstallation();

  if (!installed) {
    return null;
  }

  return (
    <ToolConnectionStatusCard
      title="Coco installed in Slack"
      description={
        teamId !== undefined
          ? `Connected to workspace ${teamId}. Coco is available in DMs and @mentions.`
          : 'Your workspace can use Coco from DMs and @mentions.'
      }
      status="connected"
      statusLabel="Installed"
      isActive={true}
    />
  );
};
